import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Layout from '../../../../components/Layout';
import { menuModifierService } from '../../../../services/menuModifierService';
import { ArrowLeft, Save } from 'lucide-react';
import '../RestaurantPage.css';

import { getServerErrorMessage } from '../../../../utils/errorUtils';
const MenuModifierCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as any;
  const existingModifier = state?.modifier;
  const isEdit = Boolean(existingModifier);

  const [menuItemId] = useState<number>(existingModifier?.menuItemId ?? state?.menuItemId ?? 0);
  const [name, setName] = useState(existingModifier?.name ?? '');
  const [modifierType, setModifierType] = useState(existingModifier?.modifierType ?? 'AddOn');
  const [additionalPrice, setAdditionalPrice] = useState<number>(existingModifier?.additionalPrice ?? 0);
  const [description, setDescription] = useState(existingModifier?.description ?? '');
  const [isActive, setIsActive] = useState(existingModifier?.isActive ?? true);
  const [sortOrder, setSortOrder] = useState<number>(existingModifier?.sortOrder ?? 0);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) { setError('Name is required.'); return; }
    setSaving(true);
    setError(null);
    try {
      if (isEdit && existingModifier?.id) {
        await menuModifierService.update(existingModifier.id, { name: name.trim(), modifierType, additionalPrice, description: description.trim() || undefined, isActive, sortOrder });
      } else {
        await menuModifierService.create({ menuItemId, name: name.trim(), modifierType, additionalPrice, description: description.trim() || undefined, isActive, sortOrder });
      }
      navigate('/restaurant/modifiers', { state: { message: isEdit ? 'Modifier updated.' : 'Modifier created.' } });
    } catch (err: any) {
      setError(getServerErrorMessage(err) ?? 'Failed to save modifier.');
      setSaving(false);
    }
  };

  return (
    <Layout>
      <div className="rest-create-page">
        <div className="ims-create-body-page">
          <div className="ims-top-bar">
            <div className="ims-top-bar-left">
              <button type="button" className="ims-back-btn" onClick={() => navigate('/restaurant/modifiers')}>
                <ArrowLeft size={16} strokeWidth={2} />
              </button>
              <div className="ims-page-title">{isEdit ? 'Edit Modifier' : 'Add Modifier'}</div>
            </div>
            <div className="ims-top-bar-right">
              <button type="button" className="ims-btn ims-btn-secondary" onClick={() => navigate('/restaurant/modifiers')} disabled={saving}>Cancel</button>
              <button type="submit" form="modifier-form" className="ims-btn ims-btn-primary" disabled={saving}>
                {saving ? <><span className="ims-btn-spinner" />Saving…</> : <><Save size={14} strokeWidth={2} />Save</>}
              </button>
            </div>
          </div>

          {error && <div className="ims-alert ims-alert-error" style={{ margin: '1rem 0' }}>{error}<button className="btn-close" onClick={() => setError(null)} /></div>}

          <div className="ims-create-body ims-create-body-single">
            <div className="ims-panel-left">
              <div className="ims-card">
                <div className="ims-card-header"><span className="ims-card-title">Modifier Details</span></div>
                <div className="ims-card-body">
                  <form id="modifier-form" onSubmit={handleSubmit}>
                    <div className="ims-form-group">
                      <label className="ims-form-label">Name <span style={{ color: 'var(--ims-red-text)' }}>*</span></label>
                      <input type="text" className="ims-form-control" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Extra Cheese" maxLength={100} />
                    </div>
                    <div className="ims-form-row">
                      <div className="ims-form-group">
                        <label className="ims-form-label">Type</label>
                        <select className="ims-form-control" value={modifierType} onChange={e => setModifierType(e.target.value)}>
                          <option value="AddOn">Add-on</option>
                          <option value="Removal">Removal</option>
                          <option value="LevelSelection">Level Selection</option>
                        </select>
                      </div>
                      <div className="ims-form-group">
                        <label className="ims-form-label">Price Impact ($)</label>
                        <input type="number" className="ims-form-control" value={additionalPrice}
                          onChange={e => setAdditionalPrice(parseFloat(e.target.value) || 0)} step="0.01" />
                        <small style={{ color: 'var(--ims-text-sub)', fontSize: '11px' }}>Use negative for discounts</small>
                      </div>
                      <div className="ims-form-group">
                        <label className="ims-form-label">Sort Order</label>
                        <input type="number" className="ims-form-control" value={sortOrder}
                          onChange={e => setSortOrder(parseInt(e.target.value) || 0)} min={0} />
                      </div>
                    </div>
                    <div className="ims-form-group">
                      <label className="ims-form-label">Description</label>
                      <textarea className="ims-form-control" value={description} onChange={e => setDescription(e.target.value)} rows={2} maxLength={500} />
                    </div>
                    <div className="ims-form-group">
                      <label className="ims-form-check" style={{ cursor: 'pointer' }}>
                        <input type="checkbox" className="ims-check-input" checked={isActive} onChange={e => setIsActive(e.target.checked)} />
                        <span className="ims-check-label">Active</span>
                      </label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MenuModifierCreatePage;
